import { render, staticRenderFns } from "./WxProductionUnitMultiSelector.vue?vue&type=template&id=087a3b5f&scoped=true"
import script from "./WxProductionUnitMultiSelector.vue?vue&type=script&lang=js"
export * from "./WxProductionUnitMultiSelector.vue?vue&type=script&lang=js"
import style0 from "./WxProductionUnitMultiSelector.vue?vue&type=style&index=0&id=087a3b5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087a3b5f",
  null
  
)

export default component.exports